import React from "react";
import SubTitle from "../SubTitle";
import Cards from "../Cards";

class ArticleList extends React.Component {

    componentDidMount() {

    }

    render() {
        return (
          <section className="rob-article__list">
              <SubTitle title={this.props.title} direction="left" />
              <div className="container">
                <Cards cards={this.props.cards} />
              </div>
          </section>
        )
    }
}

export default ArticleList;




// WEBPACK FOOTER //
// ./src/components/elements/blockLoop/ArticleList.js